





















import * as handler from '@/api/handler'

import mixins from 'vue-typed-mixins'
import pageMixin from '@/components/Mixins/page'
import linkAdsMixin from '@/components/Mixins/linkAds'

import TopWelfareCard from '@/components/Base/TopWelfareCard.vue'

/**
 * 周五专区顶部楼层
 */
export default mixins(pageMixin, linkAdsMixin).extend({
  props: {
    config: Object as () => DisplayConfig,
    inActivity: Boolean
  },

  components: {
    TopWelfareCard
  },

  data() {
    return {
      store: {} as TopWelfareItem,
      cards: [] as TopWelfareCard[],
      showCards: false
    }
  },

  computed: {
    // 周五至周日常置展开【卡片】区域的全部卡片
    autoExpandCards(): boolean {
      const date = new Date(handler.getServerTime())
      const day = date.getDay()
      return day === 0 || day >= 5
    },
    title(): string {
      // 根据是否在活动时间内 选择标题显示的文案
      return this.inActivity ? this.store.titleActive : this.store.titleInactive
    }
  },

  methods: {
    switchCardDisplay() {
      if (!this.autoExpandCards) {
        this.showCards = !this.showCards

        if (this.showCards) {
          this.logClick('topListUnfold')
        } else {
          this.logClick('topListFold')
        }
      }
    }
  },

  async mounted() {
    // @ts-ignore
    this.store = handler.getMinimumTimeActivity(this.config.friday.itemList)
    this.showCards = this.autoExpandCards

    try {
      this.cards = handler.getActiveList(this.store.cards)
    } catch (e) {
      this.reportError(e, 'err_in_friday_mounted')
    }
    this.logPageView('top')
  }
})
